import { Close, NoCamera } from '@myinterview/component-library';
import React from 'react';
import { ActorRef, DoneInvokeEvent } from 'xstate';
import { ALL_JOB_QUESTIONS_TYPE } from '../interfaces/jobInterface';
import { MODAL_ERROR_KEY } from '../interfaces/widgetInterface';
import { isMobile } from '../utils/device.utils';
import { CountDown } from './CountDown';
import { Counter } from './Counter';
import { DeviceSelector, IDeviceSelectorProps } from './DeviceSelector';
import { PermissionSteps } from './PermissionSteps';
import { RecorderModal } from './RecorderModal';
import { MicrophoneIndicator } from './ui/MicrophoneIndicator';
import { PracticeMode } from './ui/PracticeMode';
import { QuestionNumber } from './ui/QuestionNumber';

interface IProps extends IDeviceSelectorProps {
  isCameraDisplayed: boolean;
  microphoneRef: ActorRef<DoneInvokeEvent<any>, any> | null;
  isPracticeModeDisplayed: boolean;
  errorType: MODAL_ERROR_KEY | null;
  isPermissionStepsOpen: boolean;
  onDisplayPermissionSteps: () => void;
  onClosePermissionSteps: () => void;
  onReInitRecorder: () => void;
  onRecorderRetry: () => void;
  isRecorderCanChangeSettings: boolean;
  canStartRecording: boolean;
  currentQuestion: number;
  numberOfQuestions: number;
  currentQuestionObj: ALL_JOB_QUESTIONS_TYPE | undefined;
  isRecording: boolean;
  durations: number;
  recordingTime: number;
  isCountDown: boolean;
  countdown: number;
  isQuestionDisplayed: boolean;
  myinterviewRef: React.RefObject<HTMLDivElement>;
  isAssessment: boolean;
  recordWithoutVideo?: boolean;
}

export const VideoCamera = React.forwardRef<HTMLVideoElement, IProps>(({
  recordWithoutVideo, isCameraDisplayed, microphoneRef, isPracticeModeDisplayed, errorType, isPermissionStepsOpen, onDisplayPermissionSteps, onClosePermissionSteps, onRecorderRetry,
  isRecorderCanChangeSettings, videoDevices, audioDevices, selectedVideoDevice, selectedAudioDevice, handleDeviceChange, canStartRecording,
  currentQuestion, numberOfQuestions, currentQuestionObj, isRecording, durations, recordingTime, isCountDown, countdown, isQuestionDisplayed, onReInitRecorder, myinterviewRef, isAssessment,
}, videoRef) => (
  <div className={`myinterview-widget-video-camera ${!isCameraDisplayed ? 'myinterview-widget-video-camera--hidden' : ''}`}>

    {recordWithoutVideo ? (
      <div className="myinterview-widget-video-camera__recording-without-video">
        <NoCamera />
      </div>
    ) : (
      <video
        ref={videoRef}
        playsInline
        autoPlay
        disablePictureInPicture
        controls={false}
        muted
        hidden={isAssessment}
        poster="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
      />
    )}

    {canStartRecording && <QuestionNumber currentQuestion={currentQuestion} numberOfQuestions={numberOfQuestions} />}

    {isRecording && (
      <div className="myinterview-widget-video-camera__recording-counter-wrapper">
        <Counter limit={durations} counter={recordingTime} isRecording />
      </div>
    )}

    {microphoneRef && <MicrophoneIndicator microphoneRef={microphoneRef} />}

    {isPracticeModeDisplayed && <PracticeMode />}

    {isRecorderCanChangeSettings && (
      <DeviceSelector
        recordWithoutVideo={recordWithoutVideo}
        myinterviewRef={myinterviewRef}
        videoDevices={videoDevices}
        audioDevices={audioDevices}
        selectedVideoDevice={selectedVideoDevice}
        selectedAudioDevice={selectedAudioDevice}
        handleDeviceChange={handleDeviceChange}
      />
    )}

    {isCountDown && <CountDown countDown={countdown} />}

    {((errorType && (!isPermissionStepsOpen || isMobile)) || (!isRecording && isQuestionDisplayed && (!videoDevices?.length || (currentQuestionObj)))) && (
      <RecorderModal
        isRecording={isRecording}
        errorType={errorType}
        onDisplayPermissionSteps={onDisplayPermissionSteps}
        onReInitRecorder={onReInitRecorder}
        onRecorderRetry={onRecorderRetry}
        currentQuestionObj={currentQuestionObj}
        deviceList={audioDevices || []}
        selectedDevice={selectedAudioDevice}
        onDeviceSelected={handleDeviceChange}
        deviceType="audio"
      />
    )}

    {!isMobile && isPermissionStepsOpen && (
      <div className="myinterview-widget-video-camera__permissions">
        <div
          className="myinterview-widget-video-camera__permissions-close"
          onClick={onClosePermissionSteps}
          role="presentation"
        >
          <Close />
        </div>
        <PermissionSteps onRetry={onRecorderRetry} />
      </div>
    )}

  </div>
));
